export default __webpack_public_path__ + "fc89eb369cd20405c4aeafec987c2d15.png";